import Rules from '@/services/validation/rules/rules'
export default {
  data() {
    return {
      expiryDateRules: [
        v => Rules.isRequired(v),
      ]
    }
  }
}

